<div fxLayout="column" class="grouped-checkboxes">
  <div class="select-all">
    @if (showSelectAll) {
      <mat-checkbox
        [(ngModel)]="selectAll"
        [disabled]="selectAllDisabled"
        color="primary"
        ><b>Select All</b></mat-checkbox
      >
    }
    <div class="group-by">
      <span>Group by:</span>
      <mat-button-toggle-group
        [(ngModel)]="toggleValue"
        name="Group By"
        aria-label="Group people by"
        #group="matButtonToggleGroup"
        (change)="onChange($event)"
      >
        <mat-button-toggle value="positionTitle">Position</mat-button-toggle>
        <mat-button-toggle value="seatStatus">Seat Status</mat-button-toggle>
      </mat-button-toggle-group>
    </div>
  </div>
  <ng-container>
    @for (positionTitle of getGroupMapKeys(); track positionTitle) {
      <div
        fxLayout="column"
        fxLayoutGap="5px"
        class="grouped-header"
        [attr.aria-label]="positionTitle"
      >
        <mat-checkbox
          color="primary"
          [checked]="getGroupKeyStateForKey(positionTitle)"
          [disabled]="getGroupDisabledStateForKey(positionTitle)"
          (change)="setGroupKeyStateForKey(positionTitle, $event.checked)"
          [attr.aria-label]="'Select all ' + positionTitle + 's'"
        >
          <b>{{ positionTitle }}</b>
        </mat-checkbox>
        @for (item of getGroupMapValuesForKey(positionTitle); track item) {
          <mat-checkbox
            [(ngModel)]="item[keyName]"
            color="primary"
            [disabled]="isDisabled && item['disabled']"
          >
            {{ getDisplayValue(item) }}
          </mat-checkbox>
        }
      </div>
    }
  </ng-container>
</div>
